import { createSlice } from "@reduxjs/toolkit";
import {
  ICMSSlice,
  IContent,
  IContentTypes,
} from "../../models/admin/cms/contentTypes";
import { getContent, getContentTypes } from "./CMSActions";

const initialState: ICMSSlice = {
  contentTypes: [],
  content: [],
};

const cmsSlice = createSlice({
  name: "cmsSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContentTypes.fulfilled, (state, { payload }) => {
      state.contentTypes = (payload.data || []) as IContentTypes[];
    });
    builder.addCase(getContent.fulfilled, (state, { payload }) => {
      state.content = (payload.data || []) as IContent[];
    });
  },
});

export default cmsSlice.reducer;
